// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { AppStatus } from 'components/layout/AppStatus'
import { ExternalLinks } from 'constants/links'

export const NoUserRolesError = () => {
  const { t } = useTranslation()

  return (
    <AppStatus animationName="not-verified" title={t('noUserRolesError.title')}>
      <p className="text-body-regular-large text-foreground-subdued">
        {t('noUserRolesError.introduction')}
      </p>
      <p className="text-body-regular-large text-foreground-subdued">
        {t('noUserRolesError.workspaceOwner')}
      </p>
      <p className="text-body-regular-large text-foreground-subdued">
        {t('noUserRolesError.helpCenterPreText')}
        <ExternalLink href={ExternalLinks.ROLES_FAQ}>
          {t('noUserRolesError.helpCenterLink')}
        </ExternalLink>
        {`. `}
      </p>
    </AppStatus>
  )
}
